import React from 'react'

class Ruchen extends React.Component {
  render(){
    return(
      <div>
          <h1>Ruchen</h1>
            タスク管理アプリ<br/>
            Ruchenはランダムに並び替えのできるタスク管理アプリです。<br/>
            <br/>
            お問い合わせはアプリ内のお問い合わせ項目からお願いします。<br/>
            追って入力されたアドレスに返信致します。<br/><br/>

          <h2>Ruchen -プライバシーポリシー-</h2>
          <h4>はじめに</h4>
            以下はSota Iwahashi（以下，当方）が提供するスマートフォン用アプリケーション（以下「本アプリケーション」）における
            利用者情報の取り扱いを定めたものです。


            <h4>収集する情報</h4>
            本アプリケーションのご利用に際して、以下の利用者情報を取得いたします。


            <h5>アプリケーションの利用状況の収集</h5>
            当方が配信するアプリでは、広告配信のために<br/>
            Google AdMob、利用状況解析のためにGoogle Firebase Analytics, <br/>
            Google AnalyticsおよびCrashlyticsを使用する場合がございます。<br/>
            取得する情報、利用目的、第三者への提供等の詳細につきましては、以下のプライバシーポリシーのリンクよりご確認ください。<br/>
            <br/>
            <ul>
                <li>Google AdMob（Google Inc.)</li>
                <li>http://www.google.com/intl/ja/policies/technologies/ads/</li>
                <li>Google Firebase Analytics, Google Analytics（Google Inc.）</li>
                <li>https://policies.google.com/privacy?hl=ja</li>
                <li>Crashlytics（Google Inc.）</li>
                <li>https://fabric.io/terms</li>
            </ul>
            <br/>
            
            <h5>お問い合わせやご意見を頂く際の個人情報の収集</h5>
            <ul>
                <li>問い合わせ欄に入力されたお名前</li>
                <li>送信元のメールアドレス</li>
                <li>お問い合わせ内容</li>
            </ul>

            <h4>利用目的</h4>
            当方は、お問い合わせにおいて収集した情報を、そのお問い合わせに対する返信のために利用いたします。<br/>
            また、お問い合わせで収集した情報を、本アプリケーションの品質向上のために利用いたします。<br/>


            <h4>個人情報の管理</h4>
            当方は、お客さまの個人情報を正確かつ最新の状態に保ち、<br/>
            個人情報への不正アクセス・紛失・破損・改ざん・漏洩などを防止するため、<br/>
            安全対策を実施し個人情報の厳重な管理を行ないます。<br/>
            また、当方はユーザより入力された情報（テキスト、数字、添付した画像）などを<br/>
            当方利用のサーバーや外部サービスに送信・保存することは一切いたしません。<br/>
            当方が取得する個人情報はどの画面をどれぐらい利用しているか等の行動解析データや広告識別子であり、<br/>
            ユーザが入力したデータは一切お預かりしないセキュリティ体制を敷いております。<br/>

            <h4>個人情報の第三者への開示・提供の禁止</h4>
            当方は、お客さまよりお預かりした個人情報を適切に管理し、<br/>
            次のいずれかに該当する場合を除き、個人情報を第三者に開示いたしません。<br/>
            <ul>
                <li>お客さまの同意がある場合</li>
                <li>法令に基づき開示することが必要である場合</li>
            </ul>

            <h4>法令、規範の遵守と見直し</h4>
            当方は、保有する個人情報に関して適用される日本の法令、<br/>
            その他規範を遵守するとともに、本ポリシーの内容を適宜見直し、その改善に努めます。


            <h4>お問い合わせ</h4>
            アプリに関するお問い合わせは基本的にアプリ内のお問い合わせ項目よりお願いします。<br/>
            ruchen_info@yahoo.co.jp


      </div>
    )
  }
}


export default Ruchen;